<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>Induction Report</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <button
    mat-raised-button
    type="button"
    class="m-1 mr-2"
    matTooltip="Click this button to export Induction Report."
    (click)="onExport('csv')">
    <mat-icon>cloud_download</mat-icon> Export
  </button>

  <form class="form-inline my-2 my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <button
      mat-raised-button
      type="button"
      class="mr-2 mr-lg-3 my-1"
      (click)="onFilter()"
      matTooltip="Click this button to display filter options.">
      <mat-icon>filter_list</mat-icon> Filter
    </button>

    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search Assigned Users"
      aria-label="Search Assigned Users"/>

    <button
      mat-raised-button
      color="secondary"
      class="mr-2 my-1"
      type="submit"
      matTooltip="Run the current search">
      <mat-icon>search</mat-icon> Search
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table mat-table [dataSource]="dataSource" matSort matSortActive="user_id" matSortDirection="asc" matSortDisableClear>

    <ng-container matColumnDef="accounts.name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name</th>
      <td mat-cell *matCellDef="let element">{{ element?.user?.employer.name }}</td>
    </ng-container>

    <ng-container matColumnDef="users.contact_person">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Full Name
      </th>
      <td mat-cell *matCellDef="let element">
        <a (click)="onUserPublicView(element?.user.hash, $event)"
           matTooltip="View User Public Profile">
          {{ element?.user.contact_person }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="users.email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Address</th>
      <td mat-cell *matCellDef="let element">{{ element?.user.email }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">{{ element.status }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</mat-dialog-actions>
